import { useDispatch, useSelector } from 'react-redux'

import Pagination from 'components/Pagination'

import PosAccountsList from 'views/PosAccounts/List'
import { setPage } from 'store/appStateSlice'
import { getCurrentPage } from 'store/appStateSlice/selectors'
import { IPosAccountWithRoles } from 'types/posAccounts'
import { TPaginator } from 'types/paginator'
import { RootState, TLocation } from 'types/store'
import useGetPathname from 'hooks/useGetPathname'

type TProps = {
  posAccounts: IPosAccountWithRoles[]
  paginator: TPaginator<IPosAccountWithRoles>
}

const PosAccountsLayout = ({ posAccounts, paginator }: TProps) => {
  const dispatch = useDispatch()
  const { pathnameWithoutSlash } = useGetPathname()

  const handlePersistPaginationPage = (page: number) => {
    dispatch(setPage({ location: pathnameWithoutSlash as TLocation, page }))
  }

  const currentPage = useSelector((state) =>
    getCurrentPage(state as RootState, pathnameWithoutSlash as TLocation)
  )

  return (
    <div className="items">
      <div className="header">
        <ul className="header__menu">
          <li className="header__menu-item">Name</li>
          <li className="header__menu-item">Role</li>
          <li className="header__menu-item">PIN</li>
          <li className="header__menu-item">Status</li>
        </ul>
      </div>
      <PosAccountsList posAccounts={posAccounts} />
      <section className="footer">
        <Pagination
          paginator={paginator}
          handlePersistPaginationPage={handlePersistPaginationPage}
          currentPersistedPaginationPage={currentPage}
        />
      </section>
    </div>
  )
}

export default PosAccountsLayout
